import React, { useState, useEffect } from 'react';

/**
 * Custom checkbox for enabling/disabling image borders
 * Manages its own visual state while syncing with element.hasBorder
 * Solves the controlled/uncontrolled component issues with native checkboxes
 */
export default function BorderEnableCheckboxV2({
  isEnabled,
  onToggle,
}) {
  const [checked, setChecked] = useState(isEnabled);

  // Sync visual state when the element prop changes
  useEffect(() => {
    setChecked(isEnabled);
  }, [isEnabled]);

  const handleClick = () => {
    const newState = !checked;
    setChecked(newState);
    onToggle(newState);
  };

  return (
    <div className="flex items-center gap-2">
      <button
        type="button"
        onClick={handleClick}
        className={`w-4 h-4 rounded border-2 flex items-center justify-center cursor-pointer transition-colors ${
          checked
            ? 'bg-indigo-500 border-indigo-500'
            : 'bg-white border-gray-300 hover:border-gray-400'
        }`}
        aria-label="Enable border"
      >
        {checked && (
          <svg
            className="w-3 h-3 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={3}
              d="M5 13l4 4L19 7"
            />
          </svg>
        )}
      </button>
      <label
        htmlFor="enableBorder"
        className="text-xs font-medium text-gray-700 cursor-pointer"
      >
        Enable border
      </label>
    </div>
  );
}
